"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State_1 = require("./State/State");
var stateFactory = function (options) {
    if (options === void 0) { options = {}; }
    var state = new State_1.default(options);
    return state;
};
exports.default = stateFactory;
//# sourceMappingURL=stateFactory.js.map